import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { FormulaSection } from '../components/FormulaSection';
import { AboutIntro } from '../components/AboutIntro';
import { PrinciplesSection } from '../components/PrinciplesSection';
import { EcosystemSection } from '../components/EcosystemSection';
import { PhilosophySection } from '../components/PhilosophySection';
import { WorldClocksSection } from '../components/WorldClocksSection';
import { GridDivider } from '../components/GridDivider';
import { usePageMeta } from '../hooks/usePageMeta';
import { homeSeo } from '../data/seo';
type Props = {
  heroHover: 'trail' | 'ripple' | 'lens' | 'dissolve' | 'magnet';
};
export function Home({
  heroHover
}: Props) {
  const {
    hash
  } = useLocation();
  usePageMeta(homeSeo);
  useEffect(() => {
    if (hash) document.querySelector(hash)?.scrollIntoView();
  }, [hash]);
  return <>
      <Hero hoverMode={heroHover} data-id="element-453" data-mp="3oyymhd0c1lkh" />
      <WorldClocksSection data-id="element-454" data-mp="30xb9e3tcoxwq" />
      <AboutIntro data-id="element-455" data-mp="30vgnam6cezr2" />
      <FormulaSection data-id="element-456" data-mp="30w0582vzto53" />
      <PrinciplesSection data-id="element-457" data-mp="30uf7k4edtp30" />
      <EcosystemSection data-id="element-458" data-mp="2vx6swdsg036i" />
      <PhilosophySection data-id="element-459" data-mp="2vyzzjt322nei" />
      <GridDivider data-id="element-460" data-mp="2vvlw0hino85h" />
    </>;
}